import { Route, Routes } from 'react-router-dom';
import CreateRole from './pages/CreateRole';
import EditRole from './pages/EditRole';
import ListRole from './pages/ListRole';

const Role = () => {
  return (
    <Routes>
      <Route path="" element={<ListRole />} />
      <Route path="create" element={<CreateRole />} />
      <Route path="edit/:id" element={<EditRole />} />
    </Routes>
  );
};

export default Role;
